import script from "./Uploader.vue?vue&type=script&lang=ts&setup=true"
export * from "./Uploader.vue?vue&type=script&lang=ts&setup=true"

import "./Uploader.vue?vue&type=style&index=0&id=22e0d68b&scoped=true&lang=scss"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22e0d68b"]])

export default __exports__